import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {HttpService} from './http.service';
import {Export} from '../models/Export';
import {BaseResponse} from '../models/response/BaseResponse';
import {Order} from '../models/Order';
import {PaginatedDataRequest} from '../models/request/PaginatedDataRequest';
import {PaginatedDataResponse} from '../models/response/PaginatedDataResponse';


type ServiceType = Export;

@Injectable({
  providedIn: 'root'
})
export class ExportService extends HttpService {

  servicePath = 'exports';

  index(entries: number,
        page: number,
        data?: any,
        order?: Order,
        relations?: string[]): Observable<BaseResponse<PaginatedDataResponse<ServiceType>>>{
    const request = new PaginatedDataRequest<any>(entries, page, data, order, relations);
    return this.post(this.servicePath, request).pipe(
      map(response => {
        return response;
      })
    );
  }

  destroy(id: number): Observable<BaseResponse<ServiceType>>{
    return this.delete(this.servicePath, id);
  }

  download(id: number): Observable<Blob>{
    return this.post(this.servicePath + '/download/' + id, null,'blob');
  }
}
